import {
  SET_CURRENT_COMPANY,
  SET_ENTRANCES_IN_VIEW,
  SET_SEARCH_FIELD_VALUE,
  RESET_SEARCH_FIELD_VALUE,
  SET_CURRENT_HOUSE,
  SET_CURRENT_FLAT,
  SET_FLATS_GRID_DATA,
  SET_FLATS_TABLE_DATA,
  SET_FLATS_VIEW,
  SET_HOUSES_VIEW,
  SET_ACTIVE_ENTRANCE_NAME,
  SET_FLATS_TABLE_PAGE,
  SET_HOUSES_TABLE_PAGE,
  SET_DOC_FORM_DATA,
  SET_METER_MODAL_DATA,
  SET_FLATS_GRID_PREVIEW_DATA,
  SET_TEMPLATE_MODAL_DATA,
  SET_CURRENT_HOUSES_REGISTER,
  SET_SELECTED_FLATS,
  SET_AVAILABLE_HOUSE,
  SET_AVAILABLE_FLAT,
  SET_CHESS_VIEW_COLOR_MODE,
  SET_MONITORING_STAGE,
  SET_DATE_EXCESS,
  SET_REQUEST_VALUES_ATTRIBUTES,
  OPEN_MODAL_TRANSPORTS_TENANT,
  CLOSE_MODAL_TRANSPORTS_TENANT,
  SET_VISIBLE_TRANSPORT_FORM,
} from './actionsTypes';

export const setCurrentCompany = (company) => ({
  type: SET_CURRENT_COMPANY,
  payload: company,
});

export const setDateExcess = (date) => ({
  type: SET_DATE_EXCESS,
  payload: date,
});

export const setChessViewColorMode = (value) => ({
  type: SET_CHESS_VIEW_COLOR_MODE,
  payload: value,
});

export const setSelectedFlats = (selectedFlats) => ({
  type: SET_SELECTED_FLATS,
  payload: selectedFlats,
});

export const setEntrancesInView = (entranceIds) => ({
  type: SET_ENTRANCES_IN_VIEW,
  payload: entranceIds,
});

export const setSearchFieldValue = (value) => ({
  type: SET_SEARCH_FIELD_VALUE,
  payload: value,
});

export const setMonitoringStage = (value) => ({
  type: SET_MONITORING_STAGE,
  payload: value,
});

export const resetSearchFieldValue = () => ({
  type: RESET_SEARCH_FIELD_VALUE,
});

export const setCurrentHouse = (house) => {
  return {
    type: SET_CURRENT_HOUSE,
    payload: house,
  };
};

export const setCurrentFlat = (flat) => {
  return {
    type: SET_CURRENT_FLAT,
    payload: flat,
  };
};

export const setFlatsGridData = (data) => {
  return {
    type: SET_FLATS_GRID_DATA,
    payload: data,
  };
};

export const setFlatsTableData = (data) => {
  return {
    type: SET_FLATS_TABLE_DATA,
    payload: data,
  };
};

export const setAvailableHouse = (data) => {
  return {
    type: SET_AVAILABLE_HOUSE,
    payload: data,
  };
};

export const setAvailableFlat = (data) => {
  return {
    type: SET_AVAILABLE_FLAT,
    payload: data,
  };
};

export const setFlatsView = (data) => {
  return {
    type: SET_FLATS_VIEW,
    payload: data,
  };
};

export const setHousesView = (data) => {
  return {
    type: SET_HOUSES_VIEW,
    payload: data,
  };
};

export const setActiveEntranceName = (data) => {
  return {
    type: SET_ACTIVE_ENTRANCE_NAME,
    payload: data,
  };
};

export const setFlatsTablePage = (data) => {
  return {
    type: SET_FLATS_TABLE_PAGE,
    payload: data,
  };
};

export const setHousesTablePage = (page) => {
  return {
    type: SET_HOUSES_TABLE_PAGE,
    payload: page,
  };
};

export const setVisibleTransportForm = (value) => {
  return {
    type: SET_VISIBLE_TRANSPORT_FORM,
    payload: value,
  };
};

export const setDocFormData = (data) => {
  return {
    type: SET_DOC_FORM_DATA,
    payload: data,
  };
};

export const setMeterModalData = (data) => {
  return {
    type: SET_METER_MODAL_DATA,
    payload: data,
  };
};

export const setFlatsGridPreviewData = (data) => {
  return {
    type: SET_FLATS_GRID_PREVIEW_DATA,
    payload: {
      data: Array.isArray(data?.data) ? data?.data : [],
      file: data?.file instanceof File ? data?.file : null,
      houseId: data?.houseId ?? null,
    },
  };
};

export const resetFlatsGridPreviewData = () => {
  return setFlatsGridPreviewData(null);
};

export const setCurrentHousesRegister = (houses) => {
  return {
    type: SET_CURRENT_HOUSES_REGISTER,
    payload: houses,
  };
};

export const setTemplateModalData = (data) => {
  return {
    type: SET_TEMPLATE_MODAL_DATA,
    payload: data,
  };
};

export const setValuesRequestAttributes = (data) => {
  return {
    type: SET_REQUEST_VALUES_ATTRIBUTES,
    payload: data,
  };
};

export const openTransportsModal = (value) => ({
  type: OPEN_MODAL_TRANSPORTS_TENANT,
  payload: value,
});

export const closeTransportsModal = () => ({
  type: CLOSE_MODAL_TRANSPORTS_TENANT,
});
